var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrice02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0C9.55219 -4.11148e-08 6.24559 1.36964 3.80761 3.80761C1.36964 6.24558 3.01418e-07 9.55218 0 13C-3.01417e-07 16.4478 1.36964 19.7544 3.80761 22.1924C6.24558 24.6304 9.55218 26 13 26L13 13L13 0Z",
    fill: "#709506"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 26C16.4478 26 19.7544 24.6304 22.1924 22.1924C24.6304 19.7544 26 16.4478 26 13C26 9.55219 24.6304 6.24559 22.1924 3.80761C19.7544 1.36964 16.4478 1.07227e-06 13 7.70853e-07L13 13L13 26Z",
    fill: "#B8B1FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrice02);
export default __webpack_public_path__ + "static/media/price-02.c34e5177fe3bf40dcef7e2e62ff0c72a.svg";
export { ForwardRef as ReactComponent };